import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import * as api from './api';

import { ChangeTarifStateData } from './types';

const initialState: ChangeTarifStateData = {
	data: { data: { error: '', message: '' }, error: null },
	loading: false,
	error: '',
};

export const fetchSetTarif = createAsyncThunk(
	'api/fetchSetTarif',
	({ sessionId, tarifId }: { sessionId: string; tarifId: string }) => api.fetchSetTarif({ sessionId, tarifId })
);

const setTarifSlice = createSlice({
	name: 'setTarif',
	initialState,
	reducers: {},
	extraReducers(builder) {
		builder
			.addCase(fetchSetTarif.pending, (state) => {
				state.loading = true;
				state.error = '';
			})
			.addCase(fetchSetTarif.fulfilled, (state, action) => {
				state.loading = false;
				state.data = action.payload || [];
				state.error = '';
			})
			.addCase(fetchSetTarif.rejected, (state, action) => {
				state.loading = false;
				state.error = action.error.message || 'Ошибка загрузки данных';
			});
	},
});

export default setTarifSlice.reducer;
